"use client";
import { Link } from "@/i18n/navigation";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import Image from "next/image";

export default function CampaignCard({ item }) {
  const t = useTranslationDetector("common");
  // RedirectSlug varsa onu kullan, yoksa fallback olarak "/"
  const href = item?.RedirectSlug ? `/kampanyalar/${item.RedirectSlug}` : "/";

  const linkTitle = item?.Title ? item.Title : t("defaultTitle");
  return (
    <Link
      key={item.CampaignId}
      href={href}
      title={linkTitle}
      className="border-border-card mr-4 flex shrink-0 basis-[75%] cursor-pointer flex-col items-start justify-start overflow-hidden rounded-lg border sm:basis-[35%] lg:mr-6 lg:basis-[23.3%] xl:basis-[23.5%]"
    >
      <div className="rounded-t-default relative aspect-[291/250] w-full">
        <Image
          src={item.ThumbnailImageUrl || "/images/dummy/blog-dummy-3.jpg"}
          alt={item.Title || "campaign-image"}
          fill
          sizes="(max-width: 640px) 75vw, (max-width: 1024px) 35vw, 23vw"
          className="rounded-t-lg object-cover"
        />
      </div>
      <div className="flex h-full w-full flex-col items-start justify-between gap-[21px] p-4">
        <p className="text-foreground m-0 text-lg font-semibold">
          {item.Title ? item.Title : t("defaultTitle")}
        </p>

        <div className="flex w-full items-center justify-between">
          <div>
            {item.DaysLeft && (
              <p className="text-foreground bg-background-300 rounded-[6px] px-2 py-1 text-xs font-medium">
                {t("daysLeftRemaining", { count: item.DaysLeft })}
              </p>
            )}
          </div>
          <div className="flex items-center gap-1">
            {" "}
            <p className="text-primary text-sm font-medium">{t("explore")}</p>
            <FontAwesomeIcon
              className="w-5-h5"
              icon={byPrefixAndName.far["arrow-right"]}
            />
          </div>
        </div>
      </div>
    </Link>
  );
}
